import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(initReactI18next)
  .use(HttpApi)
  .use(LanguageDetector)
  .init({
    // i18next option
    fallbackLng: "en",
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    load: "languageOnly",
    // debug: process.env.NODE_ENV === "development",
    debug: false,

    // HttpApi options
    backend: {
      // Change version whenever keys are added or modified to ensure cache bust
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
      queryStringParams: {
        v: 1.2,
      },
    },

    // Language Detection options
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
    },
  });

export default i18next;
